(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/bankid-poll.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/bankid-poll.js');

'use strict';

const {
  UpdateHeader
} = svs.playerLoginReact.sharedComponents;
const {
  BankIdStart,
  BankIdWaiting
} = svs.playerLoginReact.bankid.components;
const {
  bankIdPollType,
  appWaitStatus
} = svs.playerLoginReact.constants;
const BankIdPoll = _ref => {
  let {
    isLogin = true,
    pollState = bankIdPollType.BEFORE_POLL,
    bankIdPollWait = appWaitStatus.WAITING_QRCODE
  } = _ref;
  const [preFetchedAst, setPreFetchedAst] = React.useState(null);
  const [localPollState, setLocalPollState] = React.useState(pollState);
  const [localBankIdPollWait, setLocalBankIdPollWait] = React.useState(bankIdPollWait);
  React.useEffect(() => {
    UpdateHeader.updateHeader(isLogin ? 'Logga in' : 'Bli kund');
  }, [isLogin]);
  React.useEffect(() => {
    if (preFetchedAst) {
      setLocalBankIdPollWait(appWaitStatus.WAITING_APP);
      setLocalPollState(bankIdPollType.WAITING_POLL);
    }
  }, [preFetchedAst]);
  return React.createElement(React.Fragment, null, localPollState === bankIdPollType.BEFORE_POLL && React.createElement(BankIdStart, {
    isLogin: isLogin,
    setPreFetchedAst: setPreFetchedAst,
    pollState: localPollState
  }), localPollState === bankIdPollType.WAITING_POLL && React.createElement(BankIdWaiting, {
    isLogin: isLogin,
    bankIdPollWait: localBankIdPollWait,
    preFetchedAst: preFetchedAst,
    setPreFetchedAst: setPreFetchedAst
  }));
};
svs.playerLoginReact.bankid.BankIdPoll = BankIdPoll;

 })(window);